import React, { useState, useEffect } from "react";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";

import { fetchOrganizationDetails } from "../actions";

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function OrganizationInfo(props) {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [show, setShow] = useState(false);
  const [id, setId] = useState("");
  const [customerNotFound, setCustomerNotFound] = useState();
  const [data, setData] = useState({});
  const [medicalSpecialityData, setMedicalSpecialityData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      setData(props.data);
      setMedicalSpecialityData(props.medical);
    }
    fetchData();
  }, []);

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    navigate(page);
  };

  const goToOrg = async (orgId) => {
    window.scrollTo(0, 0);
    document.body.classList.remove("sidebar-open");
    document.body.classList.add("sidebar-close-tablet");
    navigate(`/organizationInfo?orgId=${orgId}`);
    window.location.reload();
    setId(orgId);
    await fetchOrganizationDetails(orgId).then((res) => {
      if (res && res.data.success === true && res.data.data) {
        setData(
          res &&
          res.data &&
          res.data.data &&
          res.data.data.organizationInfo &&
          res.data.data.organizationInfo[0] &&
          res.data.data.organizationInfo[0]
        );

        setMedicalSpecialityData(
          res && res.data && res.data.data && res.data.data.orgSpeciality
        );
      } else if (
        res.data && res.data.success === false &&
        res.data.data && res.data.data.message === "given Request id not found"
      ) {
        setCustomerNotFound(true);
      }
    });
  };

  return (
    <>
      <div className="org-main">
        <div className="org-wrapper1">
          <h4 className="primary-title">
            {lang("OrganizationMenu.organizationInfo")}
          </h4>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.basicProfile")}</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.unifiedCustomerCode")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          /* data && data.legacyUnifiedCustomerCode  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          /*  ? data.legacyUnifiedCustomerCode       /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          data && data.unifiedCustomerCode           /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            ? data.unifiedCustomerCode               /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.customerType")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.customerTypeNameLocal
                            ? data.customerTypeNameLocal
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.ultmarcFacilityType")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.ultmarcFacilityTypeNameLocal
                            ? data.ultmarcFacilityTypeNameLocal
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.managementBodyType")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data ? 
                          (data.parentManagementBodyTypeNameLocal || "") + " " + 
                          (data.managementBodyTypeNameLocal || "") : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.ultmarcHospitalType")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data &&
                            data.ultmarcHospitalType &&
                            data.ultmarcHospitalType.value
                            ? data.ultmarcHospitalType.value
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.hundredBedsType")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data &&
                            data.hundredBedsType &&
                            data.hundredBedsType.value
                            ? data.hundredBedsType.value
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.facilityFunctionType")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data &&
                            data.facilityFunctionType &&
                            data.facilityFunctionType.value
                            ? data.facilityFunctionType.value
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.facilityClassType")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data &&
                            data.facilityClassType &&
                            data.facilityClassType.value
                            ? data.facilityClassType.value
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.custNameLocal")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.customerNameLocalAbbr
                            ? data.customerNameLocalAbbr
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.custNameLocalKana")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.customerNameLocalAbbrKana
                            ? data.customerNameLocalAbbrKana
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.postalCode")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data && data.postalCode ? data.postalCode : ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>{lang("OrganizationMenu.tel")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data && data.tel ? data.tel : ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.kanjiAddress")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data ?
                          (data.addressLine || "") : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.kanaAddress")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data ? 
                          (data.addressLineKana || "") : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang(
                          "organizationDetails.facilityRepresentativePerson"
                        )}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="cust-link">
                        <a
                          onClick={(e) =>
                            changeRoute(
                              e,
                              `/personInfo?personId=${data.representativePersonLegacyUnifiedCustomerCodePerCusId}`
                            )
                          }
                        >
                          {data &&
                            /* data.representativePersonLegacyUnifiedCustomerCode    /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            /*  ? data.representativePersonLegacyUnifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            data.representativePersonUnifiedCustomerCode             /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            ? data.representativePersonUnifiedCustomerCode         /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            : ""}
                        </a>
                        {data && data.representativePersonNameLocal
                          ? data.representativePersonNameLocal
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.supervisingPharmacist")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.supervisingPharmacistNameKanji
                            ? data.supervisingPharmacistNameKanji
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.speciality")}</h4>
            </div>
            <div className="card-body">
              <div className="row">
                {medicalSpecialityData &&
                  medicalSpecialityData.map((item, index) => {
                    return (
                      <div className="col-xl-3 col-md-6" key={index}>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            value={
                              item.medical_speciality_name_local
                                ? item.medical_speciality_name_local
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.numberOfBeds")}</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-9">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group horizon-form2">
                        <div className="custom-3">
                          <label>
                            {lang("organizationDetails.numberOfBeds")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <input
                            type="text"
                            className="form-control"
                            value={
                              data && data.numberOfBeds ? data.numberOfBeds : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group horizon-form2">
                        <div className="custom-3">
                          <label>
                            {lang("organizationDetails.maintenanceDate")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <input
                            type="text"
                            className="form-control"
                            value={
                              data && data.ultmarcMaintenanceDate
                                ? data.ultmarcMaintenanceDate
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="horizon-form2 align-top">
                        <div className="custom-3">
                          <label>
                            {lang("organizationDetails.approvedBeds")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <div className="table-responsive normal-table mb-0">
                            <table className="table" aria-describedby="table">
                              <thead>
                                <tr>
                                  <th scope="col">
                                    {lang("organizationDetails.general")}
                                  </th>
                                  <th scope="col">
                                    {lang("organizationDetails.psychiatric")}
                                  </th>
                                  <th scope="col">
                                    {lang("organizationDetails.tuberculosis")}
                                  </th>
                                  <th scope="col">
                                    {lang(
                                      "organizationDetails.infectiousDisease"
                                    )}
                                  </th>
                                  <th scope="col">
                                    {lang("organizationDetails.recuperation")}
                                  </th>
                                  <th scope="col">
                                    {lang("organizationDetails.other")}
                                  </th>
                                  <th scope="col">
                                    {lang("organizationDetails.total")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    {data && data.approvedNumberOfBedsGeneral
                                      ? data.approvedNumberOfBedsGeneral
                                      : ""}
                                  </td>
                                  <td>
                                    {data &&
                                      data.approvedNumberOfBedsPsychiatric
                                      ? data.approvedNumberOfBedsPsychiatric
                                      : ""}
                                  </td>
                                  <td>
                                    {data &&
                                      data.approvedNumberOfBedsTuberculosis
                                      ? data.approvedNumberOfBedsTuberculosis
                                      : ""}
                                  </td>
                                  <td>
                                    {data &&
                                      data.approvedNumberOfBedsInfectiousDisease
                                      ? data.approvedNumberOfBedsInfectiousDisease
                                      : ""}
                                  </td>
                                  <td>
                                    {data &&
                                      data.approvedNumberOfBedsRecuperation
                                      ? data.approvedNumberOfBedsRecuperation
                                      : ""}
                                  </td>
                                  <td>
                                    {data && data.approvedNumberOfBedsOther
                                      ? data.approvedNumberOfBedsOther
                                      : ""}
                                  </td>
                                  <td>
                                    {data && data.approvedNumberOfBedsTotal
                                      ? data.approvedNumberOfBedsTotal
                                      : ""}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.medicalArea")}</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-9">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group horizon-form2">
                        <div className="custom-3">
                          <label>
                            {lang("organizationDetails.secondMedicalArea")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <input
                            type="text"
                            className="form-control"
                            value={
                              data && data.medicalAreaName
                                ? data.medicalAreaName
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group horizon-form2">
                        <div className="custom-3">
                          <label>
                            {lang("organizationDetails.thirdMedicalArea")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <input
                            type="text"
                            className="form-control"
                            value={
                              data && data.paerntMedicalAreaName
                                ? data.paerntMedicalAreaName
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="horizon-form2">
                        <div className="custom-3">
                          <label>
                            {lang("organizationDetails.issuedDate")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <input
                            type="text"
                            className="form-control"
                            value={
                              data && data.stateProvinceIssuedDate
                                ? data.stateProvinceIssuedDate
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="horizon-form2 align-top">
                        <div className="custom-3"></div>
                        <div className="custom-9">
                          <div className="table-responsive normal-table mb-0">
                            <table className="table" aria-describedby="table">
                              <thead>
                                <tr>
                                  <th scope="col"></th>
                                  <th scope="col">
                                    {lang(
                                      "organizationDetails.psychiatricBeds"
                                    )}
                                  </th>
                                  <th scope="col">
                                    {lang(
                                      "organizationDetails.tuberculosisBeds"
                                    )}
                                  </th>
                                  <th scope="col">
                                    {lang(
                                      "organizationDetails.infectiousDiseaseBeds"
                                    )}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    {lang("organizationDetails.standardBeds")}
                                  </td>
                                  <td>
                                    {data && data.psychosisStandardBeds
                                      ? data.psychosisStandardBeds
                                      : ""}
                                  </td>
                                  <td>
                                    {data && data.tuberculosisStandardBeds
                                      ? data.tuberculosisStandardBeds
                                      : ""}
                                  </td>
                                  <td>
                                    {data && data.infectiousDiseasesStandardBeds
                                      ? data.infectiousDiseasesStandardBeds
                                      : ""}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {lang("organizationDetails.existingBeds")}
                                  </td>
                                  <td>
                                    {data && data.psychosisExistingBeds
                                      ? data.psychosisExistingBeds
                                      : ""}
                                  </td>
                                  <td>
                                    {data && data.tuberculosisExistingBeds
                                      ? data.tuberculosisExistingBeds
                                      : ""}
                                  </td>
                                  <td>
                                    {data && data.infectiousDiseasesExistingBeds
                                      ? data.infectiousDiseasesExistingBeds
                                      : ""}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    {lang("organizationDetails.shortageBeds")}
                                  </td>
                                  <td>
                                    {data && data.psychosisShortageBeds
                                      ? data.psychosisShortageBeds
                                      : ""}
                                  </td>
                                  <td>
                                    {data && data.tuberculosisShortageBeds
                                      ? data.tuberculosisShortageBeds
                                      : ""}
                                  </td>
                                  <td>
                                    {data && data.infectiousDiseasesShortageBeds
                                      ? data.infectiousDiseasesShortageBeds
                                      : ""}
                                  </td>
                                </tr>
                                <tr>
                                  <td>{lang("organizationDetails.date")}</td>
                                  <td>
                                    {data && data.psychosisExistingBedsAt
                                      ? data.psychosisExistingBedsAt
                                      : ""}
                                  </td>
                                  <td>
                                    {data && data.tuberculosisExistingBedsAt
                                      ? data.tuberculosisExistingBedsAt
                                      : ""}
                                  </td>
                                  <td>
                                    {data &&
                                      data.infectiousDiseasesExistingBedsAt
                                      ? data.infectiousDiseasesExistingBedsAt
                                      : ""}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.maintenanceInfo")}</h4>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.relatedUniversityCustomer")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="cust-link">
                        <a
                          onClick={() =>
                            goToOrg(
                              data.relatedUniversityCustomerLegacyUnifiedCustomerCodeOrgId
                            )
                          }
                        >
                          {data &&
                            /* data.relatedUniversityCustomerLegacyUnifiedCustomerCode    /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            /*  ? data.relatedUniversityCustomerLegacyUnifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            data.relatedUniversityCustomerUnifiedCustomerCode             /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            ? data.relatedUniversityCustomerUnifiedCustomerCode         /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            : ""}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.nursingHomeCustomer")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="cust-link">
                        <a
                          onClick={() =>
                            goToOrg(
                              data.nursingHomeMedicalRoomCustomerLegacyUnifiedCustomerCodeOrgId
                            )
                          }
                        >
                          {data &&
                            /*  data.nursingHomeMedicalRoomCustomerLegacyUnifiedCustomerCode}  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            data.nursingHomeMedicalRoomCustomerUnifiedCustomerCode           /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.drugStoreCustomer")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="cust-link">
                        <a
                          onClick={() =>
                            goToOrg(
                              data.drugStoreChainHeadOfficeCustomerLegacyUnifiedCustomerCodeOrgId
                            )
                          }
                        >
                          {data &&
                            /* data.drugStoreChainHeadOfficeCustomerLegacyUnifiedCustomerCode}  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            data.drugStoreChainHeadOfficeCustomerUnifiedCustomerCode      /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.wholesalerCompany")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data && data.wholesalerCompany ? data.wholesalerCompany : ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.plannedOpeningFlag")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.plannedOpeningFlag === "1" ? true : false
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.closedFlag")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data && data.closedFlag === "1" ? true : false}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.wardClosure")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.ultmarcWardClosedType
                            ? data.ultmarcWardClosedType
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.reexaminationType")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.ultmarcReexaminzationType
                            ? data.ultmarcReexaminzationType
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.unknownAddress")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.ultmarcAddressUnknownType
                            ? data.ultmarcAddressUnknownType
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.closedYearMonth")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.establishedClosedYearMonth
                            ? data.establishedClosedYearMonth
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.plannedDeleteReason")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.UltmarcPlannedDeleteReason
                            ? data.UltmarcPlannedDeleteReason
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.duplicatedCustomer")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="cust-link">
                        <a
                          onClick={() =>
                            goToOrg(
                              data.duplicatedCustomerLegacyUnifiedCustomerCodeOrgId
                            )
                          }
                        >
                          {data &&
                            /* data.duplicatedCustomerLegacyUnifiedCustomerCode}  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            data.duplicatedCustomerUnifiedCustomerCode            /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.ultmarcModifiedDate")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.ultmarcProcessedDate
                            ? data.ultmarcProcessedDate
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.ultmarcModificationType")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.ultmarcModificationType
                            ? data.ultmarcModificationType
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.defaultAddressBlock")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.defaultAddressBlockCode
                            ? `${data.defaultAddressBlockCode} : ${data.full_address_text_local}` 
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group horizon-form2">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.overrideOrgCustomerBlock")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.overrideCustomerBlockCode
                            ? `${data?.overrideCustomerBlockCode} : ${data?.orgcust_block_name}` 
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        className="withdraw-modal"
        show={customerNotFound}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            <img src="images/warning2.svg" alt="Warning" />
            {lang("errorMessages.CUSTOMER_NOT_FOUND")}
          </div>
          <p className="mb-3">
            {lang("errorMessages.SEARCH_REQUESTS")}
            <a
              className="link"
              onClick={(e) => {
                changeRoute(e, "/organizationCustomer");
              }}
            >
              {lang("Menu.organizationCustomer")}
            </a>
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default OrganizationInfo;
